import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { TranslationContext } from "../../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../../hooks/useCurrentUserRoles";
import { sendEmail } from "../../../services/httpService";

export default function SubmitNewCategory() {

    const { translations } = useContext( TranslationContext );
    const { currentUser } = useCurrentUserRoles();
    const [ suggestionSkills, setSuggestionSkills ] = useState( '' );

    const handleSubmit = async ( event ) => {
        event.preventDefault();
        const message = "Bonjour,\r\nJ'aimerais ajouter une nouvelle compétence à la plateforme :";
        const userName = currentUser.prenom;
        const userLastname = currentUser.nom;
        const emailContent = `${ message } ${ suggestionSkills }\r\nMessage envoyé par ${ userName } ${ userLastname }`;
        const emailRequest = {
            to: '',
            subject: "Nouvelle suggestion de compétence",
            content: emailContent
        };

        try {
            const response = await sendEmail( emailRequest );
            await response.text();
            toast.success( "Message envoyé avec succès" );
            setSuggestionSkills( '' );
        } catch ( error ) {
            console.error( "Erreur lors de l'envoi de l'email", error );
            toast.error( "Erreur lors de l'envoi du message" );
        }
    };

    return (
        <div className="d-flex gap-2 align-items-center">
            <p className="fst-italic mt-3">
                { translations.businessSkillsSection.skillNotFoundLabel }
            </p>
            <form onSubmit={ handleSubmit } className="d-flex gap-1">
                <input
                    type="text"
                    className="form-control text-white"
                    value={ suggestionSkills }
                    onChange={ ( e ) => setSuggestionSkills( e.target.value ) }
                    placeholder="Indiquez la ici"
                    style={ { backgroundColor: 'transparent' } }
                />
                <button type="submit" className="btn_primary">
                    <MDBIcon far icon="paper-plane" title="Envoyer"/>
                </button>
            </form>
            <p className="fst-italic mt-3">{ translations.traiter }</p>
        </div>
    );
}
